import { useState } from "react";
import "./WeatherTemperature.css"

export default function WeatherTemperature(props) {
    const [unit, setUnit] = useState("celsius");

    function showFahrenheit(event) {
        event.preventDefault();
        setUnit("fahrenheit");
    }

    function showCelsius(event) {
        event.preventDefault();
        setUnit("celsius");
    }

    if (unit === "celsius") {
        return (
            <div className="weatherTemperature">
                <span className="temperature">{Math.round(props.celsius)}</span>
                <span className="unit">
                    <span className={`unit-link ${unit === "celsius" ? "active" : ""}`} onClick={showCelsius}>°C</span> |{" "}
                    <span className={`unit-link ${unit === "fahrenheit" ? "active" : ""}`} onClick={showFahrenheit}>°F</span>
                </span>
            </div>
        );
    } else {
        let fahrenheit = (props.celsius * 9) / 5 + 32;
        return (
            <div className="weatherTemperature">
                <span className="temperature">{Math.round(fahrenheit)}</span>
                <span className="unit">
                    <span className={`unit-link ${unit === "celsius" ? "active" : ""}`} onClick={showCelsius}>°C</span> |{" "}
                    <span className={`unit-link ${unit === "fahrenheit" ? "active" : ""}`} onClick={showFahrenheit}>°F</span>
                </span>
            </div>
        );
    }
}